import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';

import { type DefinitionMapper } from '../../../ai';

import { type SchedulerDefinition } from './scheduler.definition';

export class SchedulerDefinitionMapper implements DefinitionMapper<'scheduler'> {
  readonly type = 'scheduler';

  extract(_element: CanvasElementFrom<'scheduler'>): PartialDeep<SchedulerDefinition> {
    return {};
  }
}
